/**
 * EmailJS Service for sending QR codes to visitors
 */
import emailjs from '@emailjs/browser';

// EmailJS Configuration
const EMAILJS_SERVICE_ID = 'service_iu3wiic';
const EMAILJS_TEMPLATE_ID = 'template_8siafaq';
const EMAILJS_PUBLIC_KEY = 'vJoE8yr7XUfaWhI9a';

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

/**
 * Send QR code email to visitor
 * @param {Object} params - Email parameters
 * @param {string} params.to_email - Recipient email
 * @param {string} params.visitor_name - Visitor's name
 * @param {string} params.property_name - Property name
 * @param {string} params.area - Visit area
 * @param {string} params.reason - Visit reason
 * @param {string} params.visit_date - Visit date formatted
 * @param {string} params.expiration_date - Expiration date formatted
 * @param {string} params.qr_code_base64 - QR code as base64 data URL
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const sendQRCodeEmail = async ({
  to_email,
  visitor_name,
  property_name,
  area,
  reason,
  visit_date,
  expiration_date,
  qr_code_base64
}) => {
  try {
    // Validate required fields
    if (!to_email || !visitor_name) {
      return {
        success: false,
        message: 'Email y nombre del visitante son requeridos'
      };
    }

    // Prepare template parameters
    const templateParams = {
      to_email,
      visitor_name,
      property_name: property_name || 'Control de Accesos',
      area: area || 'General',
      reason: reason || 'Visita',
      visit_date: visit_date || new Date().toLocaleDateString('es-MX'),
      expiration_date: expiration_date || 'No especificada',
      qr_image: qr_code_base64 || '',
      // For inline image in email body - 150x150 to stay under 50KB limit
      qr_image_html: qr_code_base64 
        ? `<img src="${qr_code_base64}" alt="Código QR" style="width:150px;height:150px;display:block;margin:20px auto;">`
        : ''
    };

    // Send email via EmailJS
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    if (response.status === 200) {
      return {
        success: true,
        message: `Email enviado exitosamente a ${to_email}`
      };
    } else {
      return {
        success: false,
        message: 'Error al enviar el email'
      };
    }
  } catch (error) {
    const errorMessage = error?.text || error?.message || 'Error desconocido';
    return {
      success: false,
      message: `Error al enviar email: ${errorMessage}`
    };
  }
};

/**
 * Generate QR code as base64 data URL
 * Uses the existing QRCode library
 */
export const generateQRBase64 = async (qrCode, size = 200) => {
  // We'll use the canvas approach to get base64 from QR
  const QRCode = (await import('react-qr-code')).default;
  
  // Create a temporary canvas to render QR and get base64
  return new Promise((resolve) => {
    // For react-qr-code, we need to use SVG to canvas approach
    // This is a simplified version - the actual implementation will use
    // the QR code data URL from the PNG download function
    resolve(null);
  });
};

export default {
  sendQRCodeEmail
};
